import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Pedidos({ planId, onVolver }) {
  const [pedidos, setPedidos] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [productos, setProductos] = useState([]);
  const [vacios, setVacios] = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [mostrarLista, setMostrarLista] = useState(false);
  const [planInfo, setPlanInfo] = useState(null);
  const [editando, setEditando] = useState(null);
  const [editandoVacioPersonalizado, setEditandoVacioPersonalizado] = useState(false);
  const [busquedaEdit, setBusquedaEdit] = useState('');
  const [productosEdit, setProductosEdit] = useState([]);
  const [mostrarListaEdit, setMostrarListaEdit] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [busquedaVacioForm, setBusquedaVacioForm] = useState('');
  const [vaciosFiltrados, setVaciosFiltrados] = useState([]);
  const [mostrarListaVacioForm, setMostrarListaVacioForm] = useState(false);
  const [busquedaVacioEdit, setBusquedaVacioEdit] = useState('');
  const [vaciosFiltradosEdit, setVaciosFiltradosEdit] = useState([]);
  const [mostrarListaVacioEdit, setMostrarListaVacioEdit] = useState(false);
  const [mostrarResumen, setMostrarResumen] = useState(false);
  const [resumenExpandido, setResumenExpandido] = useState({});
  const [form, setForm] = useState({
    proveedor_id: '',
    producto_id: '',
    cantidad_pedida: '',
    precio: '',
    kg_estimado: '',
    bultos: '',
    estado_mercaderia: '',
    vacio_id_manual: '',
    cantidad_vacios: '',
    vacio_personalizado: false
  });

  const token = localStorage.getItem('token');

  const cargarDatos = async () => {
    try {
      const [pedidosRes, provRes, planRes, vaciosRes] = await Promise.all([
        axios.get(`https://comprasmercadomodelo.online/api/pedidos/plan/${planId}`, { headers: { authorization: token } }),
        axios.get('https://comprasmercadomodelo.online/api/pedidos/proveedores', { headers: { authorization: token } }),
        axios.get('https://comprasmercadomodelo.online/api/planes', { headers: { authorization: token } }),
        axios.get('https://comprasmercadomodelo.online/api/admin/vacios', { headers: { authorization: token } })
      ]);
      setPedidos(pedidosRes.data);
      setProveedores(provRes.data);
      setVacios(vaciosRes.data);
      const plan = planRes.data.find(p => p.id === planId);
      setPlanInfo(plan);
    } catch (err) { console.error(err); }
  };

  const filtrarVacios = (texto, esEdicion = false) => {
    if (esEdicion) {
      setBusquedaVacioEdit(texto);
      if (texto.length < 1) { setVaciosFiltradosEdit([]); setMostrarListaVacioEdit(false); return; }
      const filtrados = vacios.filter(v => v.nombre.toLowerCase().includes(texto.toLowerCase()));
      setVaciosFiltradosEdit(filtrados);
      setMostrarListaVacioEdit(true);
    } else {
      setBusquedaVacioForm(texto);
      if (texto.length < 1) { setVaciosFiltrados([]); setMostrarListaVacioForm(false); return; }
      const filtrados = vacios.filter(v => v.nombre.toLowerCase().includes(texto.toLowerCase()));
      setVaciosFiltrados(filtrados);
      setMostrarListaVacioForm(true);
    }
  };

  const buscarProductos = async (texto, esEdicion = false) => {
    if (esEdicion) {
      setBusquedaEdit(texto);
      if (texto.length < 2) { setProductosEdit([]); setMostrarListaEdit(false); return; }
    } else {
      setBusqueda(texto);
      setProductoSeleccionado(null);
      setForm(f => ({ ...f, producto_id: '', vacio_id_manual: '', vacio_personalizado: false, cantidad_vacios: '' }));
      setBusquedaVacioForm('');
      if (texto.length < 2) { setProductos([]); setMostrarLista(false); return; }
    }
    try {
      const res = await axios.get(
        `https://comprasmercadomodelo.online/api/pedidos/productos?busqueda=${encodeURIComponent(texto)}`,
        { headers: { authorization: token } }
      );
      if (esEdicion) { setProductosEdit(res.data); setMostrarListaEdit(true); }
      else { setProductos(res.data); setMostrarLista(true); }
    } catch (err) { console.error(err); }
  };

  const seleccionarProducto = (producto, esEdicion = false) => {
    if (esEdicion) {
      setEditando(e => ({ ...e, producto_id: producto.id, producto_nombre: producto.nombre, producto_codigo: producto.codigo_barras, vacio_id: producto.vacio_id, vacio_nombre: producto.vacio_nombre }));
      setBusquedaEdit(`${producto.codigo_barras} - ${producto.nombre}`);
      setProductosEdit([]);
      setMostrarListaEdit(false);
    } else {
      setProductoSeleccionado(producto);
      setForm(f => ({ ...f, producto_id: producto.id, vacio_id_manual: '', vacio_personalizado: false, cantidad_vacios: '' }));
      setBusquedaVacioForm('');
      setBusqueda(`${producto.codigo_barras} - ${producto.nombre}`);
      setProductos([]);
      setMostrarLista(false);
    }
  };

  useEffect(() => { cargarDatos(); }, [planId]);

  const toggleVerificado = async (proveedorId, verificado) => {
    try {
      await axios.put(`https://comprasmercadomodelo.online/api/cierre/planes/${planId}/proveedores/${proveedorId}/verificar`,
        { verificado }, { headers: { authorization: token } }
      );
      cargarDatos();
    } catch (err) { console.error(err); }
  };

  const mostrarMensaje = (msg) => {
    setMensaje(msg);
    setTimeout(() => setMensaje(''), 3000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.producto_id) { alert('Seleccioná un producto de la lista'); return; }
    try {
      await axios.post('https://comprasmercadomodelo.online/api/pedidos', {
        ...form,
        plan_id: planId,
        vacio_id_manual: form.vacio_personalizado ? (form.vacio_id_manual || null) : null,
        cantidad_vacios: form.vacio_personalizado ? (form.cantidad_vacios || null) : null
      }, { headers: { authorization: token } });
      setForm(f => ({ ...f, producto_id: '', cantidad_pedida: '', precio: '', kg_estimado: '', bultos: '', estado_mercaderia: '', vacio_id_manual: '', cantidad_vacios: '', vacio_personalizado: false }));
      setProductoSeleccionado(null);
      setBusqueda('');
      setBusquedaVacioForm('');
      setVaciosFiltrados([]);
      cargarDatos();
      mostrarMensaje('✅ Pedido agregado correctamente');
    } catch (err) { console.error(err); }
  };

  const iniciarEdicion = (pedido) => {
    setEditando({ ...pedido });
    setEditandoVacioPersonalizado(!!pedido.cantidad_vacios);
    setBusquedaEdit(`${pedido.producto_codigo} - ${pedido.producto_nombre}`);
    setBusquedaVacioEdit(pedido.vacio_nombre || '');
  };

  const guardarEdicion = async () => {
    try {
      await axios.put(`https://comprasmercadomodelo.online/api/pedidos/${editando.id}`, {
        proveedor_id: editando.proveedor_id,
        producto_id: editando.producto_id,
        cantidad_pedida: editando.cantidad_pedida,
        precio: editando.precio,
        kg_estimado: editando.kg_estimado,
        bultos: editando.bultos,
        estado_mercaderia: editando.estado_mercaderia,
        vacio_id_manual: editandoVacioPersonalizado ? (editando.vacio_id || null) : null,
        cantidad_vacios: editandoVacioPersonalizado ? (editando.cantidad_vacios || null) : null
      }, { headers: { authorization: token } });
      setEditando(null);
      setEditandoVacioPersonalizado(false);
      setBusquedaVacioEdit('');
      cargarDatos();
      mostrarMensaje('✅ Pedido actualizado correctamente');
    } catch (err) { console.error(err); }
  };

  const eliminarPedido = async (id) => {
    if (window.confirm('¿Eliminar este pedido?')) {
      await axios.delete(`https://comprasmercadomodelo.online/api/pedidos/${id}`, { headers: { authorization: token } });
      cargarDatos();
      mostrarMensaje('✅ Pedido eliminado');
    }
  };

  const getSubtotalMerc = (p) => Number(p.precio) * Number(p.cantidad_pedida);
  const getSubtotalVacio = (p) => {
    const cantV = p.cantidad_vacios !== null && p.cantidad_vacios !== undefined ? Number(p.cantidad_vacios) : Number(p.cantidad_pedida);
    return Number(p.precio_vacio) * cantV;
  };

  // Resumen por producto agrupado
  const resumenProductos = Object.values(
    pedidos.reduce((acc, p) => {
      const key = p.producto_nombre;
      if (!acc[key]) acc[key] = { nombre: key, codigo: p.producto_codigo, items: [], cantTotal: 0, subTotal: 0 };
      acc[key].items.push(p);
      acc[key].cantTotal += Number(p.cantidad_pedida);
      acc[key].subTotal += getSubtotalMerc(p);
      return acc;
    }, {})
  ).sort((a, b) => a.nombre.localeCompare(b.nombre));

  const pedidosPorProveedor = pedidos.reduce((acc, p) => {
    const key = p.proveedor_nombre;
    if (!acc[key]) acc[key] = [];
    acc[key].push(p);
    return acc;
  }, {});

  const proveedoresOrdenados = Object.keys(pedidosPorProveedor).sort();
  const totalGeneral = pedidos.reduce((acc, p) => acc + getSubtotalMerc(p), 0);
  const totalVaciosGeneral = pedidos.reduce((acc, p) => acc + getSubtotalVacio(p), 0);
  const totalBultos = pedidos.reduce((acc, p) => acc + (Number(p.bultos) || 0), 0);
  const capacidad = planInfo?.capacidad_bultos || 0;
  const alertaBultos = capacidad > 0 && (capacidad - totalBultos) <= 100;

  const getEstadoLabel = (estado) => {
    const estados = {
      verde: { label: '🟢 Verde', style: styles.estadoVerde },
      punto_medio: { label: '🟡 Punto medio', style: styles.estadoMedio },
      maduro: { label: '🟠 Maduro', style: styles.estadoMaduro },
      demasiado_maduro: { label: '🔴 Demasiado maduro', style: styles.estadoDemasiado }
    };
    return estados[estado] || null;
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.botonVolver} onClick={onVolver}>← Volver a Planes</button>
        <h3 style={styles.titulo}>📦 Pedidos del Plan</h3>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button style={styles.botonResumen} onClick={() => setMostrarResumen(true)}>
            📊 Ver resumen
          </button>
          <button style={styles.botonNuevo} onClick={() => setMostrarForm(!mostrarForm)}>
            {mostrarForm ? '✕ Cancelar' : '+ Agregar Pedido'}
          </button>
        </div>
      </div>

      {mensaje && <div style={styles.mensajeBox}>{mensaje}</div>}

      <div style={styles.resumenPlan}>
        <div style={styles.resumenItem}>
          <span style={styles.resumenLabel}>🛒 Subtotal mercadería</span>
          <span style={styles.resumenValor}>${totalGeneral.toLocaleString('es-AR', { minimumFractionDigits: 2 })}</span>
        </div>
        <div style={styles.resumenItem}>
          <span style={styles.resumenLabel}>🧺 Subtotal vacíos</span>
          <span style={styles.resumenValor}>${totalVaciosGeneral.toLocaleString('es-AR', { minimumFractionDigits: 2 })}</span>
        </div>
        <div style={{ ...styles.resumenItem, backgroundColor: '#eafaf1' }}>
          <span style={styles.resumenLabel}>💰 Total general</span>
          <span style={{ ...styles.resumenValor, color: '#27ae60' }}>${(totalGeneral + totalVaciosGeneral).toLocaleString('es-AR', { minimumFractionDigits: 2 })}</span>
        </div>
        <div style={styles.resumenItem}>
          <span style={styles.resumenLabel}>🚛 Flete</span>
          <span style={styles.resumenValor}>{planInfo?.flete_tipo || '-'}</span>
        </div>
        {capacidad > 0 && (
          <div style={{ ...styles.resumenItem, backgroundColor: alertaBultos ? '#ffeaa7' : '#eafaf1' }}>
            <span style={styles.resumenLabel}>📦 Bultos</span>
            <span style={{ ...styles.resumenValor, color: alertaBultos ? '#e74c3c' : '#27ae60' }}>
              {totalBultos} / {capacidad}
              {alertaBultos && ' ⚠️ Quedan menos de 100!'}
            </span>
          </div>
        )}
        <div style={styles.resumenItem}>
          <span style={styles.resumenLabel}>📋 Proveedores</span>
          <span style={styles.resumenValor}>{proveedoresOrdenados.length}</span>
        </div>
        <div style={styles.resumenItem}>
          <span style={styles.resumenLabel}>📦 Productos</span>
          <span style={styles.resumenValor}>{pedidos.length}</span>
        </div>
      </div>

      {/* Panel lateral resumen */}
      {mostrarResumen && (
        <div style={styles.panelOverlay} onClick={() => setMostrarResumen(false)}>
          <div style={styles.panelLateral} onClick={e => e.stopPropagation()}>
            <div style={styles.panelHeader}>
              <span style={styles.panelTitulo}>📊 Resumen por producto</span>
              <button style={styles.panelCerrar} onClick={() => setMostrarResumen(false)}>✕</button>
            </div>
            <div style={styles.panelContenido}>
              <div style={styles.panelStats}>
                <span style={styles.panelStat}>{resumenProductos.length} productos únicos</span>
                <span style={styles.panelStat}>${totalGeneral.toLocaleString('es-AR', { minimumFractionDigits: 0 })}</span>
              </div>
              {resumenProductos.map((prod) => (
                <div key={prod.nombre} style={styles.resumenFila}>
                  <div style={styles.resumenFilaHeader}
                    onClick={() => setResumenExpandido(e => ({ ...e, [prod.nombre]: !e[prod.nombre] }))}>
                    <div style={styles.resumenFilaIzq}>
                      <span style={styles.resumenFilaToggle}>{resumenExpandido[prod.nombre] ? '▲' : '▼'}</span>
                      <span style={styles.resumenFilaNombre}>{prod.nombre}</span>
                    </div>
                    <div style={styles.resumenFilaDer}>
                      <span style={styles.resumenFilaCant}>{prod.cantTotal} u.</span>
                      <span style={styles.resumenFilaSubt}>${prod.subTotal.toLocaleString('es-AR', { minimumFractionDigits: 0 })}</span>
                    </div>
                  </div>
                  {resumenExpandido[prod.nombre] && (
                    <div style={styles.resumenDetalle}>
                      {prod.items.map((item, i) => (
                        <div key={i} style={styles.resumenDetalleItem}>
                          <span style={styles.resumenDetalleProv}>{item.proveedor_nombre}</span>
                          <span style={styles.resumenDetalleCant}>{item.cantidad_pedida} u.</span>
                          <span style={styles.resumenDetalleSubt}>${getSubtotalMerc(item).toLocaleString('es-AR', { minimumFractionDigits: 0 })}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {mostrarForm && (
        <div style={styles.formulario}>
          <h4 style={styles.tituloForm}>Nuevo Pedido</h4>
          <form onSubmit={handleSubmit}>
            <div style={styles.campo}>
              <label style={styles.label}>Proveedor</label>
              <select style={styles.input} value={form.proveedor_id}
                onChange={(e) => setForm({ ...form, proveedor_id: e.target.value })} required>
                <option value="">Seleccionar proveedor...</option>
                {proveedores.map(p => (
                  <option key={p.id} value={p.id}>{p.nombre}</option>
                ))}
              </select>
            </div>

            <div style={styles.campo}>
              <label style={styles.label}>Buscar Producto</label>
              <input style={styles.input} type="text"
                placeholder="Ej: RUCULA o 2309..."
                value={busqueda}
                onChange={(e) => buscarProductos(e.target.value)}
                onFocus={() => busqueda.length >= 2 && setMostrarLista(true)}
                onBlur={() => setTimeout(() => setMostrarLista(false), 200)}
                autoComplete="off" />
              {mostrarLista && productos.length > 0 && (
                <div style={styles.desplegable}>
                  {productos.map(p => (
                    <div key={p.id} style={styles.opcion}
                      onMouseDown={(e) => { e.preventDefault(); seleccionarProducto(p); }}>
                      <span style={styles.codigoProducto}>{p.codigo_barras}</span>
                      <span style={styles.nombreProducto}>{p.nombre}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {productoSeleccionado && (
              <div style={styles.vacioInfo}>
                <div style={styles.vacioFila}>
                  {!form.vacio_personalizado && (
                    <>
                      {productoSeleccionado.vacio_nombre ? (
                        <span>🧺 Vacío automático: <strong>{productoSeleccionado.vacio_nombre}</strong></span>
                      ) : (
                        <span style={{ color: '#95a5a6' }}>🧺 Sin vacío</span>
                      )}
                    </>
                  )}
                  <label style={styles.checkVacioLabel}>
                    <input type="checkbox"
                      checked={form.vacio_personalizado}
                      onChange={(e) => setForm({ ...form, vacio_personalizado: e.target.checked, vacio_id_manual: '', cantidad_vacios: '' })} />
                    &nbsp; Vacío personalizado
                  </label>
                </div>
                {form.vacio_personalizado && (
                  <div style={styles.vacioPersonalizado}>
                    <div style={styles.vacioPersonalizadoFila}>
                      <div style={{ ...styles.campo, position: 'relative' }}>
                        <label style={styles.label}>Buscar vacío</label>
                        <input style={styles.input} type="text"
                          placeholder="Ej: pollero, jaula..."
                          value={busquedaVacioForm}
                          onChange={(e) => filtrarVacios(e.target.value)}
                          onBlur={() => setTimeout(() => setMostrarListaVacioForm(false), 200)}
                          autoComplete="off" />
                        {form.vacio_id_manual && (
                          <span style={styles.vacioSeleccionado}>
                            ✅ {vacios.find(v => v.id == form.vacio_id_manual)?.nombre}
                          </span>
                        )}
                        {mostrarListaVacioForm && vaciosFiltrados.length > 0 && (
                          <div style={styles.desplegable}>
                            {vaciosFiltrados.map(v => (
                              <div key={v.id} style={styles.opcion}
                                onMouseDown={() => {
                                  setForm({ ...form, vacio_id_manual: v.id });
                                  setBusquedaVacioForm(v.nombre);
                                  setMostrarListaVacioForm(false);
                                }}>
                                <span style={styles.nombreProducto}>{v.nombre}</span>
                                <span style={{ color: '#7f8c8d', fontSize: '12px' }}>${v.precio}</span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      <div style={styles.campo}>
                        <label style={styles.label}>Cantidad de vacíos</label>
                        <input style={styles.input} type="number" placeholder="Ej: 1"
                          value={form.cantidad_vacios}
                          onChange={(e) => setForm({ ...form, cantidad_vacios: e.target.value })} />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            <div style={styles.fila}>
              <div style={styles.campo}>
                <label style={styles.label}>Cantidad</label>
                <input style={styles.input} type="number" placeholder="0"
                  value={form.cantidad_pedida}
                  onChange={(e) => setForm({ ...form, cantidad_pedida: e.target.value })} required />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Precio $</label>
                <input style={styles.input} type="number" placeholder="0"
                  value={form.precio}
                  onChange={(e) => setForm({ ...form, precio: e.target.value })} required />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Kg/bulto est.</label>
                <input style={styles.input} type="number" placeholder="0"
                  value={form.kg_estimado}
                  onChange={(e) => setForm({ ...form, kg_estimado: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>📦 Bultos</label>
                <input style={styles.input} type="number" placeholder="0"
                  value={form.bultos}
                  onChange={(e) => setForm({ ...form, bultos: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>🌿 Estado</label>
                <select style={styles.input} value={form.estado_mercaderia}
                  onChange={(e) => setForm({ ...form, estado_mercaderia: e.target.value })}>
                  <option value="">Sin especificar</option>
                  <option value="verde">🟢 Verde</option>
                  <option value="punto_medio">🟡 Punto medio</option>
                  <option value="maduro">🟠 Maduro</option>
                  <option value="demasiado_maduro">🔴 Demasiado maduro</option>
                </select>
              </div>
            </div>
            <button style={styles.botonGuardar} type="submit"
              disabled={!form.producto_id || !form.proveedor_id}>
              💾 Guardar Pedido
            </button>
          </form>
        </div>
      )}

      {editando && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h4 style={styles.modalTitulo}>✏️ Editar Pedido</h4>
            <div style={styles.campo}>
              <label style={styles.label}>Proveedor</label>
              <select style={styles.input} value={editando.proveedor_id}
                onChange={(e) => setEditando({ ...editando, proveedor_id: e.target.value })}>
                {proveedores.map(p => (
                  <option key={p.id} value={p.id}>{p.nombre}</option>
                ))}
              </select>
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Producto</label>
              <input style={styles.input} type="text"
                placeholder="Buscar producto..."
                value={busquedaEdit}
                onChange={(e) => buscarProductos(e.target.value, true)}
                onBlur={() => setTimeout(() => setMostrarListaEdit(false), 200)}
                autoComplete="off" />
              {mostrarListaEdit && productosEdit.length > 0 && (
                <div style={styles.desplegable}>
                  {productosEdit.map(p => (
                    <div key={p.id} style={styles.opcion}
                      onMouseDown={(e) => { e.preventDefault(); seleccionarProducto(p, true); }}>
                      <span style={styles.codigoProducto}>{p.codigo_barras}</span>
                      <span style={styles.nombreProducto}>{p.nombre}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div style={styles.vacioInfo}>
              <div style={styles.vacioFila}>
                {!editandoVacioPersonalizado && (
                  <span style={{ color: '#2c3e50', fontSize: '14px' }}>
                    🧺 Vacío: <strong>{editando.vacio_nombre || 'Sin vacío'}</strong>
                  </span>
                )}
                <label style={styles.checkVacioLabel}>
                  <input type="checkbox"
                    checked={editandoVacioPersonalizado}
                    onChange={(e) => setEditandoVacioPersonalizado(e.target.checked)} />
                  &nbsp; Vacío personalizado
                </label>
              </div>
              {editandoVacioPersonalizado && (
                <div style={styles.vacioPersonalizado}>
                  <div style={styles.vacioPersonalizadoFila}>
                    <div style={{ ...styles.campo, position: 'relative' }}>
                      <label style={styles.label}>Buscar vacío</label>
                      <input style={styles.input} type="text"
                        placeholder="Ej: pollero, jaula..."
                        value={busquedaVacioEdit}
                        onChange={(e) => filtrarVacios(e.target.value, true)}
                        onBlur={() => setTimeout(() => setMostrarListaVacioEdit(false), 200)}
                        autoComplete="off" />
                      {editando.vacio_id && (
                        <span style={styles.vacioSeleccionado}>
                          ✅ {vacios.find(v => v.id == editando.vacio_id)?.nombre}
                        </span>
                      )}
                      {mostrarListaVacioEdit && vaciosFiltradosEdit.length > 0 && (
                        <div style={styles.desplegable}>
                          {vaciosFiltradosEdit.map(v => (
                            <div key={v.id} style={styles.opcion}
                              onMouseDown={() => {
                                setEditando({ ...editando, vacio_id: v.id });
                                setBusquedaVacioEdit(v.nombre);
                                setMostrarListaVacioEdit(false);
                              }}>
                              <span style={styles.nombreProducto}>{v.nombre}</span>
                              <span style={{ color: '#7f8c8d', fontSize: '12px' }}>${v.precio}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <div style={styles.campo}>
                      <label style={styles.label}>Cantidad de vacíos</label>
                      <input style={styles.input} type="number" placeholder="Ej: 1"
                        value={editando.cantidad_vacios || ''}
                        onChange={(e) => setEditando({ ...editando, cantidad_vacios: e.target.value })} />
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div style={styles.fila}>
              <div style={styles.campo}>
                <label style={styles.label}>Cantidad</label>
                <input style={styles.input} type="number"
                  value={editando.cantidad_pedida}
                  onChange={(e) => setEditando({ ...editando, cantidad_pedida: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Precio $</label>
                <input style={styles.input} type="number"
                  value={editando.precio}
                  onChange={(e) => setEditando({ ...editando, precio: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Kg/bulto</label>
                <input style={styles.input} type="number"
                  value={editando.kg_estimado}
                  onChange={(e) => setEditando({ ...editando, kg_estimado: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Bultos</label>
                <input style={styles.input} type="number"
                  value={editando.bultos}
                  onChange={(e) => setEditando({ ...editando, bultos: e.target.value })} />
              </div>
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Estado mercadería</label>
              <select style={styles.input} value={editando.estado_mercaderia || ''}
                onChange={(e) => setEditando({ ...editando, estado_mercaderia: e.target.value })}>
                <option value="">Sin especificar</option>
                <option value="verde">🟢 Verde</option>
                <option value="punto_medio">🟡 Punto medio</option>
                <option value="maduro">🟠 Maduro</option>
                <option value="demasiado_maduro">🔴 Demasiado maduro</option>
              </select>
            </div>
            <div style={styles.modalBotones}>
              <button style={styles.botonGuardar} onClick={guardarEdicion}>💾 Guardar cambios</button>
              <button style={styles.botonCancelar} onClick={() => { setEditando(null); setEditandoVacioPersonalizado(false); setBusquedaVacioEdit(''); }}>✕ Cancelar</button>
            </div>
          </div>
        </div>
      )}

      <div style={styles.listaProveedores}>
        {proveedoresOrdenados.length === 0 ? (
          <p style={styles.sinPedidos}>No hay pedidos cargados todavía</p>
        ) : (
          proveedoresOrdenados.map((nombreProveedor) => {
            const items = pedidosPorProveedor[nombreProveedor];
            const subtotalMerc = items.reduce((acc, p) => acc + getSubtotalMerc(p), 0);
            const subtotalVacios = items.reduce((acc, p) => acc + getSubtotalVacio(p), 0);
            const totalProveedor = subtotalMerc + subtotalVacios;
            const bultosProveedor = items.reduce((acc, p) => acc + (Number(p.bultos) || 0), 0);

            return (
              <div key={nombreProveedor} style={styles.tarjetaProveedor}>
                <div style={styles.headerProveedor}>
                  <span style={styles.nombreProveedor}>{nombreProveedor}</span>
                  <label style={{ display: "flex", alignItems: "center", gap: "5px", color: "white", fontSize: "13px", cursor: "pointer" }}>
                    <input type="checkbox" checked={!!items[0]?.verificado}
                      onChange={(e) => toggleVerificado(items[0]?.proveedor_id, e.target.checked)} />
                    Verificado
                  </label>
                  <div style={styles.headerDerecha}>
                    {bultosProveedor > 0 && <span style={styles.bultosProveedor}>📦 {bultosProveedor} bultos</span>}
                    <span style={styles.subtotalMercProv}>🛒 ${subtotalMerc.toLocaleString('es-AR', { minimumFractionDigits: 2 })}</span>
                    {subtotalVacios > 0 && <span style={styles.subtotalVaciosProv}>🧺 ${subtotalVacios.toLocaleString('es-AR', { minimumFractionDigits: 2 })}</span>}
                    <span style={styles.totalProveedor}>💰 ${totalProveedor.toLocaleString('es-AR', { minimumFractionDigits: 2 })}</span>
                  </div>
                </div>
                <table style={styles.tableEl}>
                  <thead>
                    <tr style={styles.thead}>
                      <th style={styles.th}>Código</th>
                      <th style={styles.th}>Producto</th>
                      <th style={styles.th}>Cant.</th>
                      <th style={styles.th}>Precio $</th>
                      <th style={styles.th}>Kg/bulto</th>
                      <th style={styles.th}>Bultos</th>
                      <th style={styles.th}>Estado</th>
                      <th style={styles.th}>Vacío</th>
                      <th style={styles.th}>Cant. Vacíos</th>
                      <th style={styles.th}>$ Vacío</th>
                      <th style={styles.th}>Subt. Merc.</th>
                      <th style={styles.th}>Subt. Vacío</th>
                      <th style={styles.th}>Total</th>
                      <th style={styles.th}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((p) => {
                      const estadoInfo = getEstadoLabel(p.estado_mercaderia);
                      const cantVacios = p.cantidad_vacios !== null && p.cantidad_vacios !== undefined ? p.cantidad_vacios : p.cantidad_pedida;
                      const subtMerc = getSubtotalMerc(p);
                      const subtVacio = getSubtotalVacio(p);
                      const totalFila = subtMerc + subtVacio;
                      return (
                        <tr key={p.id} style={{ ...styles.tr, backgroundColor: p.cantidad_vacios !== null ? '#fffbea' : 'white' }}>
                          <td style={styles.tdCodigo}>{p.producto_codigo}</td>
                          <td style={styles.tdNombre}>{p.producto_nombre}</td>
                          <td style={styles.tdCent}>{p.cantidad_pedida}</td>
                          <td style={styles.tdCent}>${Number(p.precio).toLocaleString('es-AR')}</td>
                          <td style={styles.tdCent}>{p.kg_estimado > 0 ? `${p.kg_estimado}kg` : '-'}</td>
                          <td style={styles.tdCent}>{p.bultos || '-'}</td>
                          <td style={styles.td}>{estadoInfo ? <span style={estadoInfo.style}>{estadoInfo.label}</span> : '-'}</td>
                          <td style={styles.td}>
                            {p.vacio_nombre ? (
                              <span>{p.vacio_nombre}{p.cantidad_vacios !== null && <span style={styles.varBadge}> ✏️ var</span>}</span>
                            ) : <span style={styles.sinVacio}>Sin vacío</span>}
                          </td>
                          <td style={styles.tdCent}>{cantVacios}</td>
                          <td style={styles.tdCent}>${Number(p.precio_vacio).toLocaleString('es-AR')}</td>
                          <td style={styles.tdCent}>${subtMerc.toLocaleString('es-AR')}</td>
                          <td style={{ ...styles.tdCent, color: subtVacio > 0 ? '#f39c12' : '#95a5a6' }}>
                            ${subtVacio.toLocaleString('es-AR')}
                          </td>
                          <td style={{ ...styles.tdCent, fontWeight: 'bold', color: '#27ae60' }}>
                            ${totalFila.toLocaleString('es-AR')}
                          </td>
                          <td style={styles.td}>
                            <div style={{ display: 'flex', gap: '5px' }}>
                              <button style={styles.botonEditar} onClick={() => iniciarEdicion(p)}>✏️</button>
                              <button style={styles.botonEliminar} onClick={() => eliminarPedido(p.id)}>🗑️</button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

const styles = {
  container: { padding: '20px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' },
  titulo: { color: '#2c3e50', fontSize: '22px', margin: 0 },
  botonVolver: { backgroundColor: '#95a5a6', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', cursor: 'pointer' },
  botonNuevo: { backgroundColor: '#27ae60', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', cursor: 'pointer' },
  botonResumen: { backgroundColor: '#8e44ad', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', cursor: 'pointer' },
  mensajeBox: { backgroundColor: '#d5f5e3', border: '1px solid #27ae60', padding: '12px 20px', borderRadius: '8px', marginBottom: '15px', color: '#27ae60', fontWeight: 'bold' },
  resumenPlan: { display: 'flex', gap: '15px', marginBottom: '20px', flexWrap: 'wrap' },
  resumenItem: { backgroundColor: 'white', padding: '15px 20px', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', display: 'flex', flexDirection: 'column', gap: '5px', minWidth: '150px' },
  resumenLabel: { fontSize: '12px', color: '#7f8c8d' },
  resumenValor: { fontSize: '16px', fontWeight: 'bold', color: '#2c3e50' },
  panelOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 10000, display: 'flex', justifyContent: 'flex-end' },
  panelLateral: { backgroundColor: 'white', width: '420px', maxWidth: '95vw', height: '100%', display: 'flex', flexDirection: 'column', boxShadow: '-4px 0 20px rgba(0,0,0,0.2)' },
  panelHeader: { backgroundColor: '#8e44ad', padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  panelTitulo: { color: 'white', fontWeight: 'bold', fontSize: '16px' },
  panelCerrar: { background: 'none', border: 'none', color: 'white', fontSize: '20px', cursor: 'pointer' },
  panelContenido: { flex: 1, overflowY: 'auto', padding: '10px' },
  panelStats: { display: 'flex', justifyContent: 'space-between', padding: '10px 12px', backgroundColor: '#f8f0ff', borderRadius: '8px', marginBottom: '10px', fontSize: '13px', color: '#8e44ad', fontWeight: 'bold' },
  panelStat: { color: '#8e44ad' },
  resumenFila: { borderBottom: '0.5px solid #ecf0f1', marginBottom: '2px' },
  resumenFilaHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 10px', cursor: 'pointer', borderRadius: '6px', hover: { backgroundColor: '#f8f9fa' } },
  resumenFilaIzq: { display: 'flex', alignItems: 'center', gap: '8px', flex: 1 },
  resumenFilaToggle: { fontSize: '10px', color: '#95a5a6', width: '12px' },
  resumenFilaNombre: { fontSize: '13px', color: '#2c3e50', fontWeight: '500' },
  resumenFilaDer: { display: 'flex', gap: '12px', alignItems: 'center' },
  resumenFilaCant: { fontSize: '12px', color: '#7f8c8d', minWidth: '40px', textAlign: 'right' },
  resumenFilaSubt: { fontSize: '13px', color: '#27ae60', fontWeight: 'bold', minWidth: '80px', textAlign: 'right' },
  resumenDetalle: { backgroundColor: '#f8f9fa', borderRadius: '6px', margin: '4px 0 8px 20px', padding: '4px 0' },
  resumenDetalleItem: { display: 'flex', justifyContent: 'space-between', padding: '5px 12px', fontSize: '12px' },
  resumenDetalleProv: { color: '#2980b9', flex: 1 },
  resumenDetalleCant: { color: '#7f8c8d', minWidth: '40px', textAlign: 'right' },
  resumenDetalleSubt: { color: '#2c3e50', minWidth: '80px', textAlign: 'right' },
  formulario: { backgroundColor: 'white', padding: '25px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', marginBottom: '20px' },
  tituloForm: { color: '#2c3e50', marginBottom: '20px' },
  fila: { display: 'flex', gap: '15px', marginBottom: '15px', flexWrap: 'wrap' },
  campo: { flex: 1, display: 'flex', flexDirection: 'column', position: 'relative', marginBottom: '15px', minWidth: '120px' },
  label: { fontSize: '13px', color: '#7f8c8d', marginBottom: '5px' },
  input: { padding: '10px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px' },
  desplegable: { position: 'absolute', top: '100%', left: 0, right: 0, backgroundColor: 'white', border: '1px solid #ddd', borderRadius: '6px', maxHeight: '250px', overflowY: 'auto', zIndex: 9999, boxShadow: '0 4px 15px rgba(0,0,0,0.2)' },
  opcion: { padding: '10px 15px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0', display: 'flex', gap: '10px', alignItems: 'center' },
  codigoProducto: { backgroundColor: '#3498db', color: 'white', padding: '2px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' },
  nombreProducto: { fontSize: '14px', color: '#2c3e50' },
  vacioInfo: { backgroundColor: '#eafaf1', border: '1px solid #27ae60', padding: '10px 15px', borderRadius: '6px', marginBottom: '15px', fontSize: '14px' },
  vacioFila: { display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' },
  checkVacioLabel: { display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '13px', color: '#2c3e50', backgroundColor: '#f0f8f0', padding: '5px 10px', borderRadius: '6px', border: '1px solid #a9dfbf' },
  vacioPersonalizado: { marginTop: '10px', borderTop: '1px solid #a9dfbf', paddingTop: '10px' },
  vacioPersonalizadoFila: { display: 'flex', gap: '15px', flexWrap: 'wrap' },
  vacioSeleccionado: { fontSize: '12px', color: '#27ae60', marginTop: '4px' },
  sinVacio: { color: '#95a5a6', fontSize: '13px' },
  varBadge: { backgroundColor: '#fef9e7', color: '#f39c12', padding: '1px 5px', borderRadius: '3px', fontSize: '11px' },
  botonGuardar: { backgroundColor: '#2980b9', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', marginTop: '10px' },
  botonCancelar: { backgroundColor: '#95a5a6', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', marginTop: '10px' },
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  modal: { backgroundColor: 'white', padding: '30px', borderRadius: '10px', width: '90%', maxWidth: '700px', maxHeight: '90vh', overflowY: 'auto' },
  modalTitulo: { color: '#2c3e50', marginBottom: '20px', fontSize: '18px' },
  modalBotones: { display: 'flex', gap: '10px', marginTop: '20px' },
  listaProveedores: { display: 'flex', flexDirection: 'column', gap: '15px' },
  sinPedidos: { textAlign: 'center', color: '#95a5a6', padding: '40px' },
  tarjetaProveedor: { backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', overflow: 'hidden' },
  headerProveedor: { backgroundColor: '#2c3e50', padding: '12px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' },
  nombreProveedor: { color: 'white', fontWeight: 'bold', fontSize: '15px' },
  headerDerecha: { display: 'flex', gap: '15px', alignItems: 'center', flexWrap: 'wrap' },
  subtotalMercProv: { color: 'rgba(255,255,255,0.8)', fontSize: '13px' },
  subtotalVaciosProv: { color: '#f39c12', fontSize: '13px' },
  totalProveedor: { color: '#2ecc71', fontWeight: 'bold', fontSize: '15px' },
  bultosProveedor: { color: '#3498db', fontSize: '13px' },
  tableEl: { width: '100%', borderCollapse: 'collapse' },
  thead: { backgroundColor: '#f8f9fa' },
  th: { color: '#7f8c8d', padding: '10px 12px', textAlign: 'left', fontSize: '12px', borderBottom: '1px solid #ecf0f1', whiteSpace: 'nowrap' },
  tr: { borderBottom: '1px solid #ecf0f1' },
  td: { padding: '10px 12px', fontSize: '13px', color: '#2c3e50' },
  tdCodigo: { padding: '10px 12px', fontSize: '12px', color: '#3498db', fontWeight: 'bold', whiteSpace: 'nowrap' },
  tdNombre: { padding: '10px 12px', fontSize: '13px', color: '#2c3e50', minWidth: '150px' },
  tdCent: { padding: '10px 12px', fontSize: '13px', color: '#2c3e50', textAlign: 'center' },
  botonEditar: { backgroundColor: '#f0f0f0', border: '1px solid #ddd', padding: '4px 8px', borderRadius: '4px', cursor: 'pointer' },
  botonEliminar: { backgroundColor: '#e74c3c', color: 'white', border: 'none', padding: '4px 8px', borderRadius: '4px', cursor: 'pointer' },
  estadoVerde: { backgroundColor: '#eafaf1', color: '#27ae60', padding: '2px 8px', borderRadius: '4px', fontSize: '12px' },
  estadoMedio: { backgroundColor: '#fef9e7', color: '#f39c12', padding: '2px 8px', borderRadius: '4px', fontSize: '12px' },
  estadoMaduro: { backgroundColor: '#fef0e7', color: '#e67e22', padding: '2px 8px', borderRadius: '4px', fontSize: '12px' },
  estadoDemasiado: { backgroundColor: '#fdeaea', color: '#e74c3c', padding: '2px 8px', borderRadius: '4px', fontSize: '12px' }
};

export default Pedidos;
